import {Route, Switch} from "react-router-dom";
import ExporterPortPairList from "./ExporterPortPairList";

const App = ({match}) => (
    <Switch>
        <Route exact path={`${match.url}`} component={ExporterPortPairList} />
    </Switch>
)

export default App;